import { useOutfits } from '@/data/Content/Outfits';
import { createContext, useContext } from 'react';

type ModalOutfitsContextType = ReturnType<typeof useOutfits> & {
	isMobile: boolean;
	onClose: () => void;
};

export const ModalOutfitsContext = createContext<ModalOutfitsContextType>({
	isMobile: false,
	totalSelectedAmount: 0,
	products: [],
	availability: [],
	isLoadingProducts: false,
	isLoadingAvailability: false,
	isValidSizesSelection: false,
	productsSelected: {},
	productSelectCount: 0,
	settings: {} as any,
	addToCart: async () => {},
	onToggleCheckProduct: () => {},
	onSelectChildrenProduct: () => {},
	onClose: () => {},
});

export const ModalOutfitsProvider = ModalOutfitsContext.Provider;

export const useModalOutfitsContext = () => {
	const context = useContext(ModalOutfitsContext);

	if (!context) {
		throw new Error('useModalOutfitsContext must be used within a ModalOutfitsProvider');
	}
	return context;
};
